import { render, staticRenderFns } from "./info_h5.vue?vue&type=template&id=1952d42e&scoped=true&"
import script from "./info_h5.vue?vue&type=script&lang=js&"
export * from "./info_h5.vue?vue&type=script&lang=js&"
import style0 from "./info_h5.vue?vue&type=style&index=0&id=1952d42e&scoped=true&lang=css&"
import style1 from "./info_h5.vue?vue&type=style&index=1&id=1952d42e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1952d42e",
  null
  
)

export default component.exports